import React from "react";
import {connect} from "react-redux";
import {setCurrentStep, setStepAndContact} from "../reducers/stepsAction";
import {bindActionCreators} from "redux";
import history from "../router/history";

class Steps extends React.Component {
    render() {
        return (
            <ul className="pagination">
                <li className={'page-item' + (this.props.currentStep == 1 ? ' active' : "")}>
                    <span
                        onClick={() => this.props.history.push(`/kund/${this.props.urlParams.id}`)} className="page-link">1
                    </span>
                </li>
                <li className={'page-item' + (this.props.currentStep == 2 ? ' active' : "")}>
                    <span onClick={() => this.props.history.push(`/kund/${this.props.urlParams.id}/apartment`)} className="page-link">2</span>
                </li>
                <li className={'page-item' + (this.props.currentStep == 3 ? ' active' : "")}>
                    <span className="page-link">3</span>
                </li>
            </ul>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        currentStep: state.stepsReducer.currentStep,
        housingCompanyPath: state.simpleReducer.housingCompanyPath
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentStep: bindActionCreators(setCurrentStep, dispatch),
        setStepAndContact: bindActionCreators(setStepAndContact, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Steps);
